var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5276 26.4874V26.9429C21.5276 27.0637 21.4797 27.1795 21.3942 27.2649C21.3088 27.3504 21.193 27.3983 21.0722 27.3983H12.8734C12.7526 27.3983 12.6367 27.3504 12.5513 27.2649C12.4659 27.1795 12.4179 27.0637 12.4179 26.9429V26.4874L13.7844 25.5764V22.8435H20.1612V25.5764L21.5276 26.4874Z",
    fill: "#A4B0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9045 21.3512H28.4927V20.763V9.68908C28.4927 9.01967 28.2231 8.37933 27.7457 7.90849C27.2686 7.43791 26.6232 7.17497 25.952 7.17497H7.4028C6.73154 7.17497 6.08616 7.43791 5.60908 7.90849C5.13172 8.37933 4.86204 9.01967 4.86204 9.68908V20.763V21.3512H5.45026H27.9045Z",
    fill: "white",
    stroke: "#4C5B66",
    strokeWidth: 1.17643
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0751 23.7175V25.4902L21.4046 26.0811V26.672C21.4046 26.8287 21.3579 26.979 21.2748 27.0899C21.1917 27.2007 21.079 27.2629 20.9614 27.2629H12.9843C12.8667 27.2629 12.754 27.2007 12.6709 27.0899C12.5878 26.979 12.5411 26.8287 12.5411 26.672V26.0811L13.8706 25.4902V21.3539",
    stroke: "#474C54",
    strokeWidth: 1.17643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8366 14.2631C15.6105 14.2631 17.8592 12.0144 17.8592 9.24044C17.8592 6.4665 15.6105 4.21777 12.8366 4.21777C10.0626 4.21777 7.8139 6.4665 7.8139 9.24044C7.8139 12.0144 10.0626 14.2631 12.8366 14.2631Z",
    fill: "white",
    stroke: "#474C54",
    strokeWidth: 1.17643
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16045 11.1209C8.61901 12.2956 9.49954 13.2569 10.6297 13.8166C11.7598 14.3762 13.0581 14.4939 14.2704 14.1466C15.4827 13.7993 16.5217 13.012 17.1841 11.9388C17.8464 10.8656 18.0843 9.58392 17.8513 8.34455C17.6182 7.10518 16.931 5.99743 15.9241 5.23815C14.9172 4.47888 13.6631 4.12277 12.4075 4.23953C11.1518 4.35629 9.98492 4.93753 9.13528 5.86944C8.28565 6.80135 7.81444 8.01683 7.8139 9.27792H17.1841",
    stroke: "#474C54",
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8729 14.3359V4.2178C12.8729 4.2178 18.6547 8.55411 12.8729 14.3359Z",
    stroke: "#474C54",
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8729 7.1734C12.8729 7.1734 7.0912 11.5097 12.8729 17.2915",
    stroke: "#474C54",
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2228 14.2631H26.1319",
    stroke: "#474C54",
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2228 13.0813H26.1319",
    stroke: "#474C54",
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2228 15.4449H26.1319",
    stroke: "#474C54",
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48058 20.4675H28.4954V21.9448C28.4954 22.2582 28.2789 22.5588 27.8934 22.7805C27.508 23.0021 26.9852 23.1266 26.4401 23.1266H6.91468C6.36958 23.1266 5.84681 23.0021 5.46136 22.7805C5.07592 22.5588 4.85938 22.2582 4.85938 21.9448V20.1721",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48058 20.4675H28.4954V21.9448C28.4954 22.2582 28.2789 22.5588 27.8934 22.7805C27.508 23.0021 26.9852 23.1266 26.4401 23.1266H6.91468C6.36958 23.1266 5.84681 23.0021 5.46136 22.7805C5.07592 22.5588 4.85938 22.2582 4.85938 21.9448V20.1721",
    stroke: "#474C54",
    strokeWidth: 1.17643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42859 8.90765V19.4956H27.7808L5.42859 8.90765Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8366 14.2631C15.6105 14.2631 17.8592 12.0143 17.8592 9.24041C17.8592 6.46647 15.6105 4.21774 12.8366 4.21774C10.0626 4.21774 7.8139 6.46647 7.8139 9.24041C7.8139 12.0143 10.0626 14.2631 12.8366 14.2631Z",
    fill: "#9CCFFF",
    stroke: "#474C54",
    strokeWidth: 1.17643
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16045 11.1208C8.61901 12.2956 9.49954 13.2569 10.6297 13.8165C11.7598 14.3762 13.0581 14.4939 14.2704 14.1465C15.4827 13.7992 16.5217 13.0119 17.1841 11.9388C17.8464 10.8656 18.0843 9.58389 17.8513 8.34452C17.6182 7.10515 16.931 5.9974 15.9241 5.23812C14.9172 4.47885 13.6631 4.12274 12.4075 4.2395C11.1518 4.35626 9.98492 4.9375 9.13528 5.86941C8.28565 6.80132 7.81444 8.0168 7.8139 9.27789H17.1841",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8729 14.3369V4.21884C12.8729 4.21884 18.6546 8.55515 12.8729 14.3369Z",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8729 4.21884C12.8729 4.21884 7.0912 8.55515 12.8729 14.3369",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.588217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8137 17.2176H21.7247",
    stroke: "#474C54",
    strokeWidth: 1.17643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8139 17.2176H8.72488",
    stroke: "#474C54",
    strokeWidth: 1.17643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6774 17.3983H25.7052",
    stroke: "#474C54",
    strokeWidth: 1.32728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteLink);
export default __webpack_public_path__ + "static/media/website-link.0de0e72b90154a4df0128fda80d66a0c.svg";
export { ForwardRef as ReactComponent };